import React from 'react';

const NoChat = () => {
  return (
    <div className="d-flex w-100 flex-grow-1 align-items-center justify-content-center font-2xl">
      Please select a chat!
    </div>
  );
};

export default NoChat;
